import { useState } from 'react';
import Alert from './Alert';

const Contact = () => {

    const [copyStatus, setCopyStatus] = useState(false); // To indicate if the text was copied

    const onCopy = () => {
        navigator.clipboard.writeText('ahmadwaseem.professional@gmail.com');
        setCopyStatus(true);
        setTimeout(() => setCopyStatus(false), 2000); 
    };


    return (
        <div className='mt-[-96px] pt-[40vh] w-full h-screen flex flex-col justify-start'>
        <div className="text-white text-center flex flex-col items-center ">

        <div className="flex flex-row flex-wrap justify-center">
            <p className="text-xl p-4">Email Address:</p>
            <p onClick={onCopy} className="transition text-xl m-4 hover:text-[#00fd9a] cursor-pointer">ahmadwaseem.professional@gmail.com</p>
        </div>

        <div className="flex flex-row flex-wrap">
            <p className="text-xl p-4">LinkedIn:</p>
            <a href="https://www.linkedin.com/in/mahmadwaseem" className="transition text-xl m-4 hover:text-[#00fd9a]">mahmadwaseem</a>
        </div>

        <div className="flex flex-row flex-wrap">
            <p className="text-xl p-4">GitHub:</p>
            <a href="https://github.com/MAhmadW" className="transition text-xl m-4 hover:text-[#00fd9a]">MAhmadW</a>
        </div>
        </div>
        {copyStatus && <Alert message={'Email copied to clipboard!'} colorClass={'bg-green-200'} />}
        </div>
    )
};

export default Contact;
